<!-- carrusel de imagenes de portada, me gustan... -->
<!-- <app-carrusel></app-carrusel> -->


<div id="letra">
    <br>
    <h2>Astronomium</h2>
</div>



<ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>  Notas </a>
      <ng-template ngbNavContent>
       
        <div class="containerr" *ngIf="cursos$ | async as cursos; else loading">
            <ng-container *ngFor="let curso of cursos">
              <mat-card class="curso-card" *ngIf="curso.tipo == 'nota'" style="background-image: url({{curso.imagen}});background-position: center;
              background-repeat: no-repeat;background-size: cover;">
                  <app-curso [curso]="curso"></app-curso>
              </mat-card>
            </ng-container>
        </div>
      </ng-template>
    </li>

    <li [ngbNavItem]="2">
      <a ngbNavLink>  Bricolaje  </a>
      <ng-template ngbNavContent>
       <app-noticias></app-noticias>
      </ng-template>
    </li>

    <li [ngbNavItem]="3">
      <a ngbNavLink>  Fotos  </a>
      <ng-template ngbNavContent>
       <app-imagen></app-imagen>
      </ng-template>
    </li>

    <li [ngbNavItem]="4">
      <a ngbNavLink>  Dibujos  </a>
      <ng-template ngbNavContent>
       <app-dibujo></app-dibujo>
      </ng-template>
    </li>

    <li [ngbNavItem]="5">
      <a ngbNavLink>  Libros  </a>
      <ng-template ngbNavContent>
       <app-libro></app-libro>
      </ng-template>
    </li>

    <li [ngbNavItem]="6">
      <a ngbNavLink>  Quienes somos  </a>
      <ng-template ngbNavContent>
       <app-quiensoy></app-quiensoy>
      </ng-template>
    </li>

    <li [ngbNavItem]="7">
      <a ngbNavLink>   Contacto   </a>
      <ng-template ngbNavContent>
        <app-about></app-about>
      </ng-template>
    </li>

    <li [ngbNavItem]="8">
      <a ngbNavLink>  Donaciones  </a>
      <ng-template ngbNavContent>
        <app-habilitar></app-habilitar>
      </ng-template>
    </li>

</ul>
<!-- <app-carrusel></app-carrusel> -->

  <div [ngbNavOutlet]="nav" class="mt-2"></div>



<!-- <app-faq *ngIf="cursos$ | async as cursos;"></app-faq> -->

<br>
<br>

<ng-template #loading>
    
    <div id="load">
    
         <div class="container-spinner">
            <mat-spinner color="accent">Cargando...</mat-spinner>
         </div>
         <!-- <img src="../../../assets/spinner.gif" alt="" id="imagenSpin"> -->
     </div>
</ng-template>